import { useState, useEffect } from "react";
import Request from "../../Helpers/Request";
import { useLocation, useNavigate } from "react-router-dom";
import { handleApiError } from "../../Helpers/handleApiError ";
import axios from "axios";
import Apiurl from "../../Helpers/apiUrl";
import { useDispatch, useSelector } from "react-redux";
import { setPasswordExpired } from "../../redux/slices/passwordSlice";
import Swal from "sweetalert2";
import { fetchMasterProduct } from "../../redux/slices/productSlice";

const ProtectedRoute = ({ children }) => {

  const [data, setData] = useState();
  const [login, setLogin] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const path = location.pathname;
  const [passwordExpireTime, setPasswordExpireTime] = useState(null);
  const currentDate = new Date();
  const hasToken = localStorage.getItem("u_token");

  useEffect(() => {
    checkLogin();
  }, [path]);

  useEffect(() => {
    dispatch(fetchMasterProduct());

    const handleOnline = () => {
      Swal.close();
      checkLogin();
    };
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  useEffect(() => {
    if (passwordExpireTime !== null && currentDate >= passwordExpireTime) {
      dispatch(setPasswordExpired(passwordExpireTime));
      navigate("/user/change-password");
    }
  }, [passwordExpireTime]);

  const checkLogin = async (retries = 3) => {
    try {
      const user = localStorage.getItem("u_token");
      if (!user) {
        handleLogout();
        return;
      }

      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user,
      };

      const response = await axios.get(`${Apiurl}profile`, { headers });
      if (
        response.status &&
        [2, 3, 4, 5, 6, 7, 8].includes(response.data.data.role_id) &&
        response.data.data.is_active == 1
      ) {
        setData(response.status);
        setLogin(response.data.data.attempt);
        const expireDate = new Date(response.data.data.password_expired_time);
        localStorage.setItem("anonymous_id", response.data?.data?.id);
        if (response.data.data.role_id !== 7) {
          const delay = 5000;
          setTimeout(() => {
            setPasswordExpireTime(expireDate);
          }, delay);
        }
      } else {
        handleLogout();
      }
    } catch (error) {
      const isUnauthorized = error.response && error.response.status === 401;
      const isNetworkError = !error.response;

      if (isUnauthorized) {
        handleLogout("Session Expired", "Your session is invalid or has expired.");
      } else if (isNetworkError) {
        if (retries > 0) {
          // Retry the request after a short delay
          setTimeout(() => checkLogin(retries - 1), 1500);
          return;
        }

        if (!navigator.onLine) {
          Swal.fire({
            icon: "warning",
            title: "Connection Lost",
            text: "Please connect to the internet to continue.",
          });
        } else {
          console.error("Server is unreachable or request blocked.");
        }
      } else {
        handleLogout("Error", "An unexpected error occurred. Please log in again.");
      }
    }
  };

  const handleLogout = (title, text) => {
    localStorage.removeItem("u_token");
    localStorage.removeItem("role_code");
    if (title) {
      Swal.fire({ icon: "error", title, text });
    }
    navigate("/");
  };

  if (hasToken) {
    if (login == 5) {
      navigate("/forgotPassword");
    }
    return children;
  } else {
    navigate("/");
    return null;
  }
};

export default ProtectedRoute;